module.exports = __webpack_public_path__ + "img/gomb-szolgaltat-aktiv.684b26b7.png";